import { React, useEffect, useState, useRef } from "react";
import { AgGridReact } from "ag-grid-react"; // the AG Grid React Component
import styled from "styled-components";
import "ag-grid-community/styles/ag-grid.css"; // Core grid CSS, always needed
import "ag-grid-community/styles/ag-theme-alpine.css"; // Optional theme CSS
import ProgressBar from 'react-bootstrap/ProgressBar';
import Upload from "../bootstrap/Upload";
import axios from "axios";
import { getAuthToken } from "../api/api";
import { getAPIUrl, notify, suppressKeyboardEvent } from "../components/common/helpers";
import { getUserDetails } from "../components/sidebar/Sidenav";
import CustomDetailsComponent from "../components/common/CustomDetailsComponent";
import { FirmwareStoreCellRenderer } from "../components/common/CustomCellRenderer";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const StyledFirmwareDetails = styled.div`
  .Deletebtn {
    background: transparent;
    border: none;
    color: white;
  }
  .Deletebtn:hover {
    background: transparent;
    border: none;
  }
  .Deletebtn:disabled {
    cursor: not-allowed;
    pointer-events: auto;
  }
`;

export default function Firmware(props) {
  const { disabledFeatures } = props;
  const [readOnly, setReadOnly] = useState(false);
  const [gridEntries, setGridEntries] = useState();
  const [title, setTitle] = useState("");
  const [countOfProgess, setCountOfProgess] = useState(0); 
  const [progressStatus, setProgressStatus] = useState(false);
  const [edit, setEdit] = useState(false);
  const [recordValues, setRecordValues] = useState();
  const [fileText, setFileText] = useState(null);
  const [gridApi, setGridApi] = useState(null);
  const gridRef = useRef();

  const controller = new AbortController();

  const handleFirmwareDetails = (field) => {
    setReadOnly(true);
    setGridEntries(field);
    setTitle(`Details of Firmware of Firmware Version - ${field.firmware_version}`);
  }

  const handleDeleteFirmware = async (field) => {
    const { file_id, file_name } = field;
    const msg = `Are you sure, you want to delete Firmware with Version ${field.firmware_version} and File Name ${field.file_name}?`;
    const confirm = window.confirm(msg);
    if (confirm) {
      const body = JSON.stringify({
        file_id,
        file_name,
        title: "FirmwareStore",
        updated_by: getUserDetails().username,
      });
      await axios({
        method: "PATCH",
        url: getAPIUrl("deleteFunctionApi"),
        headers: { Authorization: getAuthToken()},
        signal: controller.signal,
        data: body
      })
        .then((resp) => {
          if (resp){
            getFirmware();
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  const handleEdit = (field) => {
    setEdit(true);
    setRecordValues(field);
  };

  const handleDownloadReleaseNotes = async (field) => {
    const { component_type_id, firmware_version, file_name } = field;  
const params = new URLSearchParams({
    component_type_id: component_type_id,
    firmware_version: firmware_version,
    file_name:file_name
  });
  
    try {
      axios({
        method: "GET",
        url: `${getAPIUrl("releaseNoteDownload")}?${params.toString()}`,
        headers: { Authorization: getAuthToken() },
        signal: controller.signal,
      })
      .then(async (resp) => {
        
if (resp.status === 200) {
    const fileLink = resp.data;
  
    try {
      const url = new URL(fileLink);
      const fileResponse = await fetch(url.toString());
  const fileText = await fileResponse.text();
          setFileText(fileText);
          setTitle(`Release Notes of Firmware with Firmware Version - ${field.firmware_version}`);
    } catch (err) {
      console.error('Invalid or untrusted URL:', err);
    }
  }
      })
      .catch((err) => {
        err.message !== "canceled" && notify("downloading");
      });
    } catch (error) {
          console.log(error);
         notify("downloading");
        }
  }

  const column = [
    {
      headerName: "Firmware Version",
      field: "firmware_version",
      floatingFilter: true,
    },
    {
      headerName: "File Name",
      field: "file_name",
      floatingFilter: true,
    },
    {
      headerName: "Component Type",
      field: "component_type",
      floatingFilter: true,
    },
    {
      headerName: "Incompatibility",
      field: "incompatibility",
      floatingFilter: true,
      flex:1,
      minWidth: 150
    },
    {
      headerName: "Created Date",
      field: "created_date",
      floatingFilter: true,
      flex: 1,
      minWidth: 140
    },
    {
      headerName: "Release Notes",
      colId: "release_notes",
      flex: 1,
      minWidth: 100,
      cellRenderer: FirmwareStoreCellRenderer,
      cellRendererParams: {
       type : "release_notes",
       handleDownloadReleaseNotes
      }
    },
    {
      headerName: "Details",
      field: "release_details_id",
      colId: "details",
      flex: 1,
      minWidth: 100,
      cellRenderer: FirmwareStoreCellRenderer,
      cellRendererParams: {
       type : "info",
       handleFirmwareDetails
      }
    },
    {
      headerName: "Action",
      hide: disabledFeatures.includes("AddFirmware"),
      field: "file_id",
      colId: "action",
      flex:1,
      minWidth: 100,
      cellRenderer: FirmwareStoreCellRenderer,
      cellRendererParams: {
       type : "delete",
       handleDeleteFirmware,
       handleEdit
      }
    },
  ];
  const defaultColDef = {
    sortable: true,
    editable: false,
    filter: true,
    resizable: true,
    minWidth: 90,
    suppressKeyboardEvent,
  };

  const requiredKeys = {
   firmware_Description : "Firmware Description",
   created_by: "Created By",
   updated_by : "Updated By",
   updated_date : "Updated Date"
   };

   const createServerRequest = (params) => {
       const {startRow, endRow, filterModel, sortModel} = params;
       let sortQuery = '';
       let filterParams = '';
       if (sortModel && sortModel.length > 0 && sortModel !== undefined) {
        sortQuery = new URLSearchParams({
            sortColumn: sortModel[0].colId,
            sortOrder: sortModel[0].sort,
          });
       }
       if (Object.keys(filterModel).length > 0) {
        filterParams = Object.keys(filterModel).map(field => {
          const filter = filterModel[field];
          const params = new URLSearchParams({
              [field]: [filter.filter],
            });
          return `&${params}`
        }).join('');
       }
       const finalQuery = `?filter_page=${startRow}&filter_pageSize=${endRow}${filterParams.toString()}`;
       if(sortQuery !== '') {
        return finalQuery + `&${sortQuery.toString()}`;
       } else {
        return finalQuery;
        }
   }
 
   const showErrorOverlay = (gridApi) => {
     if (gridApi) {
       gridApi.showNoRowsOverlay();
     }
   };
 
   const handleApiError = (gridApi) => {
       showErrorOverlay(gridApi);
   };

   const onGridReady = (params) => {
    setGridApi(params.api);
  };

   useEffect(() => {
    if(gridApi) {
      getFirmware();
    }
   }, [gridApi]);

   const getFirmware = async () => {
    if(!gridApi) return;
    const dataSource = {
      getRows: (params) => {
        const requestParameters = createServerRequest(params);
        gridApi.showLoadingOverlay();
        axios({
                    method: "GET",
                    url:
                      getAPIUrl("getFirmwareDetails") + requestParameters,
                    headers: {
                      Authorization: getAuthToken(),
                    },
                    signal: controller.signal,
                  })
                    .then((res) => {
                      if (res && res.data.firmwareDetails.length > 0) {
                        const responseData = res.data.firmwareDetails.map((item) => ({
                          ...item
                        }));
                        params.successCallback(responseData,  res.data.lastRow);
                        gridApi.hideOverlay();
                      } 
                      else {
                        params.successCallback([], 0);
                        handleApiError(gridApi);
                      }
                    })
                    .catch((err) => {
                      params.successCallback([],  0);
                      params.failCallback();
                      handleApiError(gridApi);
                      err.message !== "canceled" && notify("fetching");
                    });
      }
    }
    gridApi.setDatasource(dataSource);
  };

  // set progress bar status update
  useEffect(() => { 
    document.title = "Firmware Store";
    const timer = setInterval(() => { 
      setCountOfProgess((oldProgress) => { 
        if (100 === oldProgress) return 0; 
        return Math.ceil(Math.min(oldProgress + Math.random() * 40, 100)); 
      }); 
    }, 1000); 
  
    return () => { 
      clearInterval(timer); 
    }; 
  }, []);


  // calling getFirmware function for first time
  useEffect(() => {
    return () => {
      controller.abort();
    };
  }, []);

  const setProgress = (status) => {
    setProgressStatus(status);
  }

  return (
    <StyledFirmwareDetails>
      <h4 className="text-white p-2">Firmware Store</h4>
      <div
        className="container-fluid"
        style={{
          background: "#1F1F1F 0% 0% no-repeat padding-box",
          border: "1px solid #707070",
          width: "100%",
        }}
      >
        <div className="text-end py-2">
          <Upload
            getFirmware={getFirmware}
            disabledFeatures={disabledFeatures}
            progressBar={setProgress}
          />
        </div>
        <div className="text-end py-2">
            {readOnly && <CustomDetailsComponent 
            gridEntries= {gridEntries}
            readOnly = {readOnly}
            setReadOnly= {setReadOnly}
            requiredKeys= {requiredKeys}
            title ={title}
              /> }
            {fileText !== null && <CustomDetailsComponent
            fileText = {fileText}  
            setFileText = {setFileText}
            setReadOnly= {setReadOnly}
            title ={title}
              /> }
        </div> 
        {
          progressStatus && 
          <div>
            <p className="progressbarlabel">Updating The Record...</p>
            <ProgressBar animated now={countOfProgess} className="progressBar"/>
          </div>
        }
        <div
          className={progressStatus ? "ag-theme-alpine-dark gridBlurEffect" : "ag-theme-alpine-dark"}
          style={{ height: 545, width: "100%" }}
        >
           {edit && (
            <Upload
              disabledFeatures={disabledFeatures}
              getFirmware={getFirmware}
              isEdit={edit}
              setEdit={setEdit}
              rowEntries={recordValues}
            />
          )}
          <AgGridReact
            onGridReady={onGridReady}
            ref={gridRef}
            rowModelType={"infinite"}
            columnDefs={column}
            defaultColDef={defaultColDef}
            pagination={true}
            paginationPageSize={10}
            cacheBlockSize={10}
            filter= {true}
            sortable={true}
          ></AgGridReact>
        </div>
        <div className="py-2"></div>
      </div>
      <ToastContainer
        style={{ width: "50%" }}
        closeOnClick={false}
        position="top-center"
        autoClose={5000}
        hideProgressBar={true}
        newestOnTop={false}
        limit={1}
      />
    </StyledFirmwareDetails>
  );
}